import { Moon } from "lucide-react";

const LINKS = ["Instagram", "TikTok", "YouTube", "Contact"];

export const Footer = () => {
  return (
    <footer className="border-t border-[#E8C27A]/10 px-6 md:px-10 py-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-2 font-display text-base tracking-[0.2em] gold-gradient-text">
          <Moon size={16} className="text-[#A99BFF]" />
          COSMIC CODE
        </div>

        <div className="flex gap-7">
          {LINKS.map((l) => (
            <a key={l} data-testid={`footer-link-${l.toLowerCase()}`} href="#" className="text-sm nav-link">
              {l}
            </a>
          ))}
        </div>

        <p data-testid="footer-copyright" className="text-xs text-[#8d87ab]">
          © {new Date().getFullYear()} Cosmic Code. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
